import { ANALYTICS_SUBJECT_ID_APP_DOCUMENTATION_LINK, ANALYTICS_SUBJECT_ID_APP_FORUMS_LINK, ANALYTICS_SUBJECT_ID_APP_ISSUE_TRACKER_LINK, ANALYTICS_SUBJECT_ID_APP_STATUS_PAGE_LINK, ANALYTICS_SUBJECT_ID_COMMUNITY_QUESTION_LINK, EVENT_CONTAINER_SUPPORT_APPLISTING_TAB, LinkClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { ExternalLink, H6 } from '@atlassian/mpac-primitives';
import * as React from 'react';
import { SupportResourcesLink } from '../../types';
import { ResourceListItem, ResourceSubTitle } from './styles';
export const DocumentationResource = props => {
  const {
    documentationUrl,
    onSupportLinkClick
  } = props;
  const fireAnalyticsEvent = useAnalyticsEvents();
  return /*#__PURE__*/React.createElement(React.Fragment, null, documentationUrl && /*#__PURE__*/React.createElement(ResourceListItem, null, /*#__PURE__*/React.createElement(H6, {
    as: "h4"
  }, "App documentation"), /*#__PURE__*/React.createElement(ResourceSubTitle, null, "Comprehensive set of documentation from the partner on", ' ', /*#__PURE__*/React.createElement(ExternalLink, {
    href: documentationUrl,
    size: "medium",
    onClick: () => {
      fireAnalyticsEvent({
        eventType: LinkClickedEvent,
        actionSubjectId: ANALYTICS_SUBJECT_ID_APP_DOCUMENTATION_LINK,
        eventContainer: EVENT_CONTAINER_SUPPORT_APPLISTING_TAB,
        attributes: {
          linkText: 'how this app works'
        }
      });
      onSupportLinkClick(SupportResourcesLink.DOCUMENTATION);
    }
  }, "how this app works"), ".")));
};
export const ForumsResource = props => {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const {
    forumsUrl,
    onSupportLinkClick
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, forumsUrl && /*#__PURE__*/React.createElement(ResourceListItem, null, /*#__PURE__*/React.createElement(H6, {
    as: "h4"
  }, "Forum"), /*#__PURE__*/React.createElement(ResourceSubTitle, null, /*#__PURE__*/React.createElement(ExternalLink, {
    href: forumsUrl,
    size: "medium",
    onClick: () => {
      fireAnalyticsEvent({
        eventType: LinkClickedEvent,
        actionSubjectId: ANALYTICS_SUBJECT_ID_APP_FORUMS_LINK,
        eventContainer: EVENT_CONTAINER_SUPPORT_APPLISTING_TAB,
        attributes: {
          linkText: 'Explore external community discussions'
        }
      });
      onSupportLinkClick(SupportResourcesLink.COMMUNITY);
    }
  }, "Explore external community discussions"), ' ', "that connect you to the Marketplace partner and other customers who use this app.")));
};
export const AtlassianCommunityResource = props => {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const {
    atlassianCommunityUrl,
    onSupportLinkClick
  } = props;
  return /*#__PURE__*/React.createElement(ResourceListItem, null, /*#__PURE__*/React.createElement(H6, {
    as: "h4"
  }, "Atlassian Community"), /*#__PURE__*/React.createElement(ResourceSubTitle, null, /*#__PURE__*/React.createElement(ExternalLink, {
    href: atlassianCommunityUrl,
    size: "medium",
    onClick: () => {
      fireAnalyticsEvent({
        eventType: LinkClickedEvent,
        actionSubjectId: ANALYTICS_SUBJECT_ID_COMMUNITY_QUESTION_LINK,
        eventContainer: EVENT_CONTAINER_SUPPORT_APPLISTING_TAB,
        attributes: {
          linkText: 'Engage with Atlassian-hosted discussions'
        }
      });
      onSupportLinkClick(SupportResourcesLink.ATLASSIAN_COMMUNITY);
    }
  }, "Engage with Atlassian-hosted discussions"), ' ', "where other customers discuss about apps."));
};
export const StatusPageResource = props => {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const {
    statusPageUrl,
    onSupportLinkClick
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, statusPageUrl && /*#__PURE__*/React.createElement(ResourceListItem, null, /*#__PURE__*/React.createElement(H6, {
    as: "h4"
  }, "Status page"), /*#__PURE__*/React.createElement(ResourceSubTitle, null, /*#__PURE__*/React.createElement(ExternalLink, {
    href: statusPageUrl,
    size: "medium",
    onClick: () => {
      fireAnalyticsEvent({
        eventType: LinkClickedEvent,
        actionSubjectId: ANALYTICS_SUBJECT_ID_APP_STATUS_PAGE_LINK,
        eventContainer: EVENT_CONTAINER_SUPPORT_APPLISTING_TAB,
        attributes: {
          linkText: 'Visit the partner status page'
        }
      });
      onSupportLinkClick(SupportResourcesLink.STATUS_PAGE);
    }
  }, "Visit the partner status page"), ' ', "to get updates on incidents or uptime.")));
};
export const IssueTrackerResource = props => {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const {
    issueTrackerUrl,
    onSupportLinkClick
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, issueTrackerUrl && /*#__PURE__*/React.createElement(ResourceListItem, null, /*#__PURE__*/React.createElement(H6, {
    as: "h4"
  }, "Issue tracker"), /*#__PURE__*/React.createElement(ResourceSubTitle, null, /*#__PURE__*/React.createElement(ExternalLink, {
    href: issueTrackerUrl,
    size: "medium",
    onClick: () => {
      fireAnalyticsEvent({
        eventType: LinkClickedEvent,
        actionSubjectId: ANALYTICS_SUBJECT_ID_APP_ISSUE_TRACKER_LINK,
        eventContainer: EVENT_CONTAINER_SUPPORT_APPLISTING_TAB,
        attributes: {
          linkText: 'Visit the issue tracker page'
        }
      });
      onSupportLinkClick(SupportResourcesLink.ISSUE_TRACKER);
    }
  }, "Visit the issue tracker page"), ' ', "to view existing bug reports and feature requests for this app.")));
};